export default "__VITE_ASSET__Di8WrO5E__"